export const MLB_SIMILARITY_MIN_PLATE_APPEARANCES = 200;
export const MLB_SIMILARITY_MIN_INNINGS_PITCHED = 40;
